require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-stephen-lardieri.json") })
        }
      }, "path---blog-author-stephen-lardieri");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-stephen-lardieri!./.cache/json/blog-author-stephen-lardieri.json
// module id = 707
// module chunks = 231608221292675